"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRefetch = require("react-refetch");

var _BoxplotCanvas = _interopRequireDefault(require("../show/BoxplotCanvas.js"));

var _TranscriptsCanvas = _interopRequireDefault(require("../show/TranscriptsCanvas.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var tryCreateBoxplotData = function tryCreateBoxplotData(_ref) {
  var dataRow = _ref.dataRow,
      columnHeaders = _ref.columnHeaders;
  var boxplotSeries = [].concat.apply([], dataRow.expressions.map(function (expression, ix) {
    return expression.quartiles ? [{
      x: ix,
      low: expression.quartiles.min,
      q1: expression.quartiles.lower,
      median: expression.quartiles.median,
      q3: expression.quartiles.upper,
      high: expression.quartiles.max
    }] : [];
  }));
  var loosePointsSeries = [].concat.apply([], dataRow.expressions.map(function (expression, ix) {
    return expression.quartiles ? [] : [{
      x: ix,
      y: expression.value
    }];
  }));

  if (boxplotSeries.length || loosePointsSeries.length) {
    return {
      boxplotSeries: boxplotSeries,
      loosePointsSeries: loosePointsSeries,
      xAxisCategories: columnHeaders.map(function (header) {
        return header.name;
      }),
      unit: dataRow.expressionUnit
    };
  } else {
    return null;
  }
};

var noData = function noData(msg) {
  return /*#__PURE__*/_react["default"].createElement("span", null, msg);
};

var makeBoxplot = function makeBoxplot(geneNameOrId, data, config) {
  return data && config && /*#__PURE__*/_react["default"].createElement(_BoxplotCanvas["default"], _extends({}, data, {
    config: config,
    titleSuffix: geneNameOrId
  }));
};

var getGeneNameOrId = function getGeneNameOrId(_ref2) {
  var name = _ref2.name,
      id = _ref2.id;
  return name ? name : id;
};

var QuietLoader = function QuietLoader(_ref3) {
  var sourceUrlFetch = _ref3.sourceUrlFetch,
      keepOnlyTheseColumnIds = _ref3.keepOnlyTheseColumnIds;
  return sourceUrlFetch.pending ? noData() : sourceUrlFetch.rejected ? noData(sourceUrlFetch) : !sourceUrlFetch.fulfilled ? noData(sourceUrlFetch) : sourceUrlFetch.value.error ? noData(sourceUrlFetch.value.error) : !sourceUrlFetch.value.geneExpression && !sourceUrlFetch.value.transcriptExpression ? noData(sourceUrlFetch.value) : /*#__PURE__*/_react["default"].createElement("div", null, sourceUrlFetch.value.geneExpression && makeBoxplot(getGeneNameOrId(sourceUrlFetch.value.geneExpression.rows[0]), tryCreateBoxplotData({
    dataRow: sourceUrlFetch.value.geneExpression.rows[0],
    columnHeaders: sourceUrlFetch.value.columnHeaders
  }), sourceUrlFetch.value.config), sourceUrlFetch.value.transcriptExpression && /*#__PURE__*/_react["default"].createElement(_TranscriptsCanvas["default"], _extends({}, sourceUrlFetch.value.transcriptExpression, {
    keepOnlyTheseColumnIds: keepOnlyTheseColumnIds,
    columnHeaders: sourceUrlFetch.value.columnHeaders,
    config: sourceUrlFetch.value.config,
    titleSuffix: getGeneNameOrId(sourceUrlFetch.value.geneExpression.rows[0])
  })));
};

var _default = (0, _reactRefetch.connect)(function (props) {
  return {
    sourceUrlFetch: {
      url: props.url
    }
  };
})(QuietLoader);

exports["default"] = _default;